import { clsx } from 'clsx'
import { createTailwindMerge, getDefaultConfig } from 'tailwind-merge'

const twMerge = createTailwindMerge(() => {
  const defaultConfig = getDefaultConfig()

  return {
    ...defaultConfig,
    prefix: 'tw',
  }
})

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function valueUpdater(updaterOrValue, ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}
